function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M8.17833 1H1.82167C1.03258 1 0.554369 1.87115 0.978013 2.53688L3.15835 5.96312C3.3668 6.29069 3.3668 6.70931 3.15835 7.03688L0.978012 10.4631C0.554368 11.1288 1.03258 12 1.82167 12H8.17833C8.96742 12 9.44563 11.1288 9.02199 10.4631L6.84165 7.03688C6.6332 6.70931 6.6332 6.29069 6.84165 5.96312L9.02199 2.53688C9.44563 1.87115 8.96742 1 8.17833 1Z",
  stroke: "currentColor",
  strokeWidth: 1.5
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M7.5 8H3L0.5 12H9.5L7.5 8Z",
  fill: "currentColor"
});

var SvgHourglass = function SvgHourglass(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 10 13",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgHourglass, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hourglass.b2a341d2.svg";
export { ForwardRef as ReactComponent };